import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class CreateUpdateRegionDeliveryRangeSettingEntity {
  region?: RegionMiniEntity
  currentRange?: number
  defaultRange?: number
  reducedRange?: number
  ratioThreshold?: number
  autoDispatchPeakRatioThreshold?: number
  manualOverrideUntil?: string | null
  isManualOverride?: boolean
}
